import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme, useLayout, useLocation, useAgentBlazeRef } from '../App';
import { Sun, Moon, LayoutGrid, Rows, Search, ChevronDown } from 'lucide-react';
const Header = () => {
  const {
    isDarkMode,
    toggleTheme
  } = useTheme();
  const {
    isQuadrantLayout,
    toggleLayout
  } = useLayout();
  const {
    currentLocation,
    setLocation,
    locations
  } = useLocation();
  const agentBlazeRef = useAgentBlazeRef();
  const navigate = useNavigate();
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  // User initials for avatar
  const userInitials = 'JD'; // Example: John Doe
  const handleLogout = () => {
    setShowUserDropdown(false);
    navigate('/login');
  };
  return <header className={`sticky top-0 z-50 ${isDarkMode ? 'bg-[#161b22]' : 'bg-[#fefefe]'} shadow-md`} data-id="element-168">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between" data-id="element-169">
        {/* Logo */}
        <div className="flex items-center" data-id="element-170">
          <div className="flex items-center" data-id="element-171">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bSa3zYvqyPEzQAksQUw4jA/image.png" alt="BLAZE Lighthouse Logo" className="h-8 mr-2" data-id="element-172" />
            <span className="font-bold text-lg" data-id="element-173">BLAZE Lighthouse</span>
          </div>
          {/* Location dropdown */}
          <div className="relative ml-4" data-id="element-174">
            <button className={`flex items-center px-3 py-1 rounded-md ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={() => setShowLocationDropdown(!showLocationDropdown)} data-id="element-175">
              {currentLocation} <ChevronDown size={16} className="ml-1" data-id="element-176" />
            </button>
            {showLocationDropdown && <div className={`absolute top-full left-0 mt-1 w-48 rounded-md shadow-lg ${isDarkMode ? 'bg-[#161b22] text-white' : 'bg-white text-black'}`} data-id="element-177">
                <ul className="py-1" data-id="element-178">
                  {locations.map(location => <li key={location} data-id="element-179">
                      <button className={`block w-full text-left px-4 py-2 text-sm ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={() => {
                  setLocation(location);
                  setShowLocationDropdown(false);
                }} data-id="element-180">
                        {location}
                      </button>
                    </li>)}
                </ul>
              </div>}
          </div>
        </div>
        {/* Right side controls */}
        <div className="flex items-center space-x-3" data-id="element-181">
          {/* Search */}
          <div className="relative" data-id="element-182">
            <button className={`p-2 rounded-full ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={() => setShowSearch(!showSearch)} title="Search" data-id="element-183">
              <Search size={20} data-id="element-184" />
            </button>
            {showSearch && <div className="absolute right-0 top-full mt-1 w-64 p-2 rounded-md shadow-lg z-10 bg-[#161b22] border border-[#30363d]" data-id="element-185">
                <input type="text" placeholder="Search products, categories..." className="w-full p-2 border border-[#30363d] rounded bg-[#0d1117] text-white" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-186" />
                {searchQuery.length >= 3 && <div className="mt-2 text-sm text-white" data-id="element-187">
                    <p className="font-bold" data-id="element-188">Products</p>
                    <ul className="pl-2" data-id="element-189">
                      <li data-id="element-190">Sample Product 1</li>
                      <li data-id="element-191">Sample Product 2</li>
                    </ul>
                  </div>}
              </div>}
          </div>
          {/* Layout toggle */}
          <button className={`p-2 rounded-full ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={toggleLayout} title={isQuadrantLayout ? 'Switch to Stacked Layout' : 'Switch to Quadrant Layout'} data-id="element-192">
            {isQuadrantLayout ? <Rows size={20} data-id="element-193" /> : <LayoutGrid size={20} data-id="element-194" />}
          </button>
          {/* Theme toggle */}
          <button className={`p-2 rounded-full ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={toggleTheme} title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'} data-id="element-195">
            {isDarkMode ? <Sun size={20} data-id="element-196" /> : <Moon size={20} data-id="element-197" />}
          </button>
          {/* User avatar/dropdown */}
          <div className="relative" data-id="element-198">
            <button className={`flex items-center justify-center w-8 h-8 rounded-full bg-[#2196f3] text-white font-medium`} onClick={() => setShowUserDropdown(!showUserDropdown)} data-id="element-199">
              {userInitials}
            </button>
            {showUserDropdown && <div className={`absolute right-0 top-full mt-1 w-48 rounded-md shadow-lg ${isDarkMode ? 'bg-[#161b22] text-white border border-[#30363d]' : 'bg-white text-black'}`} data-id="element-200">
                <ul className="py-1" data-id="element-201">
                  <li data-id="element-202">
                    <Link to="/settings" className={`block px-4 py-2 text-sm ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={() => setShowUserDropdown(false)} data-id="element-203">
                      Settings
                    </Link>
                  </li>
                  <li data-id="element-204">
                    <button className={`block w-full text-left px-4 py-2 text-sm ${isDarkMode ? 'hover:bg-[#0d1117]' : 'hover:bg-gray-100'}`} onClick={handleLogout} data-id="element-205">
                      Logout
                    </button>
                  </li>
                </ul>
              </div>}
          </div>
        </div>
      </div>
    </header>;
};
export default Header;